import { render } from "./JsonEditor.vue?vue&type=template&id=13e8a864&scoped=true"
import script from "./JsonEditor.vue?vue&type=script&lang=js"
export * from "./JsonEditor.vue?vue&type=script&lang=js"

import "./JsonEditor.vue?vue&type=style&index=0&id=13e8a864&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13e8a864"]])

export default __exports__